module.exports = __webpack_public_path__ + "img/LMI_Rescue_Blue_HEX.43481830.png";